import Figure from '../Page/Figure';

export default Figure;
